import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { TableRow, TableCell } from '@material-ui/core';

const useStyles = makeStyles({
  row: {
    height: '49px',
  },
});

const LinhaVaziaRepositorioArquivos = () => {
  const classes = useStyles();
  return (
    <TableRow
      className={classes.row}
      data-testid="linha-vazia-repositorio-arquivos"
    >
      <TableCell />
      <TableCell />
      <TableCell />
      <TableCell />
      <TableCell />
    </TableRow>
  );
};

export default LinhaVaziaRepositorioArquivos;
